


const CoulureConceptHero = ({ color, className }) => {
  return <svg
    fill={color}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    className={className}
    viewBox="0 0 1280 500" style={{ enableBbackground: "new 0 0 1280 500;" }}
    xmlSpace="preserve" >
    <path className={`opacity-70 fill-${color}`} d="M0,500h367.5c5-8.4,9.7-16.9,14.2-25.6c12.9-24.7,24-50.3,35.1-75.8c12-27.7,24.2-55.3,38.7-81.9
    c15.4-28.5,33.2-55.4,55.1-79.4c19.8-21.6,42.2-40,68.4-53.4c26.8-13.8,55.2-21.1,85.5-20.6c18.1,0.3,35.6,3.3,52.9,8.2
    c21.2,6,41.5,14.3,61.8,22.9c22.4,9.4,44.8,18.8,68,26.5c22.9,7.6,46.3,13.1,70.4,14.7c40.5,2.7,79.5-4.2,117-19.8
    c37.7-15.7,70.3-38.8,98.4-68.3c14.8-15.5,28.4-32.1,41.8-48.8c13.8-17.2,27.7-34.3,43.1-50.1c16.9-17.3,35.3-32.7,56.4-44.7
 c1.9-1.1,3.7-2.1,5.6-3.1V0H0V500z"/>
  </svg >
};

export default CoulureConceptHero;